// extracted by mini-css-extract-plugin
export var box = "_93-1";
export var checked = "_93-2";
export var descriptionSpacer = "_93-9";
export var disabled = "_93-3";
export var icon = "_93-6";
export var input = "_93-0";
export var labelSpacer = "_93-8";
export var medium = "_93-5";
export var small = "_93-4";
export var text = "_93-7";